import {useContext} from "react";
import RoomPlanContext from "../context/RoomPlanContext";

export const useRoomPlanContext = () => useContext(RoomPlanContext)